import Vue from "vue";
import Router from "vue-router";
import Consumables from "./components/Consumables.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/consumables-order",
      name: "consumables",
      component: Consumables
    }
  ]
});
